import React, { useEffect, useState } from 'react';
// import PropTypes from 'prop-types';
import AccountDropDown from './AccountDropDown';

import MenuIcon from '@mui/icons-material/Menu';
import { useDispatch, useSelector } from 'react-redux';
import { setDrawer } from '../../redux/reducers/common';
import {
  AddCustomer,
  AddFindings,
  AddFindingsToThisAsset,
  AddUsers,
  InviteCustomer,
  MyTeam,
  SeeScope,
  SlackButton,
  StartNewEASM,
  StartNewGenPT,
  StartNewPentest,
  StartNewVA,
  UpdatePentestLandScapeButton,
} from './Menu';
import ExpandedMenu from './ExpandedMenu';
import styles from './header.module.scss';
import { PermissionProvider } from '../../hoc/withPermissions';
import {
  SIEMBA_ADMIN,
  SIEMBA_CUSTOMER,
  SIEMBA_CUSTOMER_ENGINEER,
  SIEMBA_TESTER,
} from '../../utils/roles';
import { useCompany, useCustomerDetails } from '../../hooks/customer';
import { useImage } from '../../hooks/misc';
import { Divider } from '@mui/material';
import { Link, useLocation, useMatch } from 'react-router-dom';
import { useValidateLogin } from '../../hooks/auth';
import { useIsMutating } from 'react-query';
import { LOGOUT } from '../../hooks/utils/constants';
import MainLoader from '../Loader/MainLoader';
import { SLACK_CLIENT_ID } from '../../utils/constants';
import Notifications from './Notifications';
import CreditsBadge from './CreditsBadge';
import { getMainURL } from './Notifications/notification-helper';
import DropdownButton from '../Button/DropdownButton';
import AssetCriticalityDropDown from '../Inputs/AssetCriticalityDropDown';
import GlobalCompanySelection from '../Inputs/GlobalCompanySelection';
import { useAppMode } from '../../Providers/AppModeProvider';
import CollapsableAd from '../CollapsableAd';
import Storage from '../../utils/Storage';
import { useQueryClient } from 'react-query';
import useIsAuthScreen from '../../hooks/useIsAuthScreen';

const Header = (props) => {
  const dispatch = useDispatch();
  const { data } = useValidateLogin();
  const { isMenuExpanded } = useSelector((state) => state.common);
  const { data: customer, isFetching } = useCustomerDetails(data?.user?.user_type === 'customer');
  let company_logo_key = data?.user?.user_type === 'customer' ? customer?.company?.logo : '';
  let company_logo_url = useImage(company_logo_key, 'logo');
  const location = useLocation();
  const showMenu = ['/app', '/admin', '/tester'].some((el) => location.pathname.includes(el));
  const isHomeScreen = location.pathname === "/";
  const isLoggingOut = !!useIsMutating(LOGOUT);
  const { APP_MODE } = useAppMode();
  const isAuthScreen = useIsAuthScreen();

  // add findings to this asset
  const testerPath = useMatch('/tester/all_assets/:id/dashboard');
  const adminAssetDashboardPath = useMatch('/admin/all_assets/:id/dashboard');
  const adminPentestDashboardPath = useMatch('/admin/all_pentests/:id/dashboard');
  const siembaGPTAdminPath = useMatch('/admin/genpt');
  const assetLocation = testerPath || adminAssetDashboardPath;
  const asset_id = assetLocation?.params?.id;
  const mainUrl = getMainURL(data?.user?.role);

  let navHeaders = {
    showUpdatePentestLandScapeButton: true,
    showAddUsers: true,
    showAddCustomer: true,
    showAddFindingsToThisAsset: true,
    showAddFindings: true,
    showMyTeam: true,
    showSlackButton: true,
    showInviteCustomer: true,
    showStartNewPentest: true,
    showNotifications: true,
    showAccountDropDown: true,
    showGlobalCompany: true,
    showCreditsBadge: true,
  };

  if (useMatch('admin/all_pentests/:pentestId/update' || siembaGPTAdminPath)) {
    for (const key in navHeaders) {
      navHeaders[key] = false;
    }

    navHeaders.showAccountDropDown = true;
  }

  if (isAuthScreen) {
    return null;
  }

  return (
    <>
      {isLoggingOut && <MainLoader />}
      <div className="clear-both h-[50px] sm:h-[65px] hlg:h-[53px]"></div>
      {isHomeScreen ? (
        <div>
          {/* !px-0 overrides the styling for header in portal-provapt/src/index.scss */}
          <header className={'fixed w-full top-0 z-50 !px-0'}>
            <div className='container mx-auto h-full flex items-center'>
              <div className={'logo flex-grow'}>
                <Link to={mainUrl} className="h-full">
                  <img className="logo-img object-contain" src="/images/logo.png" alt="logo" />
                </Link>
                {company_logo_url && (
                  <>
                    <Divider orientation={'vertical'} className={'inline !mr-3.5'} />
                    <img src={company_logo_url} alt="" />
                  </>
                )}
              </div>
            </div>
          </header>
        </div>
      ) : (  
        <header className={'fixed w-full top-0 z-50'}>
          <nav
            className={`flex items-center ${
              adminAssetDashboardPath || adminPentestDashboardPath ? 'gap-2 xl:gap-3' : 'gap-[18px] xl:gap-[26px]'
            }`}
          >
            <div className={'menu'} style={{ cursor: 'pointer', marginLeft: '10px' }}>
              <PermissionProvider>
                {showMenu && <MenuIcon onClick={() => dispatch(setDrawer(true))} />}
              </PermissionProvider>
            </div>
            <div className={'logo flex-grow max-w-[200px] xl:max-w-none'}>
              <Link to={mainUrl} className="h-full">
                <img className="logo-img object-contain" src="/images/logo.png" alt="logo" />
              </Link>
              {company_logo_url && (
                <>
                  <Divider orientation={'vertical'} className={'inline !mr-3.5'} />
                  <img src={company_logo_url} alt="" />
                </>
              )}
            </div>
            {/* Wraps every conditional action button (varies by role) in one group so, regardless
                of which buttons are visible for the current role/breakpoint, they always sit
                together against the right edge next to notifications/avatar instead of hugging
                the logo with a dead gap in between — ml-auto on a `hidden` sibling has no layout
                effect at breakpoints where it's not rendered, so this has to live on the always-
                rendered wrapper, not on any individual button's own conditional wrapper. */}
            <div
              className={`ml-auto flex items-center ${
                adminAssetDashboardPath || adminPentestDashboardPath ? 'gap-2 xl:gap-3' : 'gap-[18px] xl:gap-[26px]'
              }`}
            >
              {/* <PermissionProvider roles={[SIEMBA_CUSTOMER, SIEMBA_ADMIN]}>
                            <div className={"hidden md:block"}>
                                {navHeaders.showUpdatePentestLandScapeButton &&
                                <UpdatePentestLandScapeButton />
                                }
                            </div>
                        </PermissionProvider> */}
              {/* ROAR-5001: every tier gets the badge for the company in scope (AC18); it renders
                  nothing itself when no company is scoped, so no role list here. */}
              <PermissionProvider>
                <div className={'hidden md:block'}>
                  {navHeaders.showCreditsBadge && <CreditsBadge />}
                </div>
              </PermissionProvider>
              <PermissionProvider roles={[SIEMBA_ADMIN]}>
                <div className={'hidden xl:block'}>{navHeaders.showAddUsers && <AddUsers />}</div>
              </PermissionProvider>
              {/* <PermissionProvider roles={[SIEMBA_ADMIN]}>
                            <div className={"hidden md:block"}>
                                {navHeaders.showAddCustomer &&
                                <AddCustomer />
                                }
                            </div>
                        </PermissionProvider> */}
              <PermissionProvider roles={[SIEMBA_TESTER, SIEMBA_ADMIN]}>
                {asset_id && (
                  <div className={'hidden md:block'}>
                    {navHeaders.showAddFindingsToThisAsset && <AddFindingsToThisAsset />}
                  </div>
                )}
              </PermissionProvider>
              <PermissionProvider roles={[SIEMBA_TESTER, SIEMBA_ADMIN]}>
                <div className={'hidden md:block'}>
                  {navHeaders.showGlobalCompany && <GlobalCompanySelection />}
                </div>
              </PermissionProvider>
              <PermissionProvider roles={[SIEMBA_ADMIN, SIEMBA_TESTER]}>
                <div className={'hidden md:block'}>
                  {navHeaders.showAddFindings && (
                    <DropdownButton
                      title="ADD"
                      color="!bg-secondary-700"
                      showAddIcon={true}
                      components={[
                        <AddFindings key="findings" />,
                        data?.user?.role == SIEMBA_ADMIN ? <AddCustomer key="customers" /> : null,
                      ]}
                    />
                  )}
                </div>
              </PermissionProvider>
              <PermissionProvider roles={[SIEMBA_ADMIN]}>
                <div className={'hidden lg:block'}>{navHeaders.showMyTeam && <MyTeam className={'whitespace-nowrap'} />}</div>
              </PermissionProvider>
              {/*<PermissionProvider roles={[SIEMBA_CUSTOMER, SIEMBA_CUSTOMER_ENGINEER]}>*/}
              {/*    <div className={"hidden md:block"}>*/}
              {/*        <SeeScope/>*/}
              {/*    </div>*/}
              {/*</PermissionProvider>*/}
              <PermissionProvider roles={[SIEMBA_CUSTOMER]}>
                <div className={'hidden md:block'}>{APP_MODE == 'genptbeta' && <CollapsableAd />}</div>
              </PermissionProvider>

              {SLACK_CLIENT_ID &&
                !isFetching &&
                !customer?.slackConnectionId &&
                APP_MODE !== 'genptbeta' && (
                  <PermissionProvider roles={[SIEMBA_CUSTOMER]}>
                    <div className={'hidden md:block'}>
                      {/* {navHeaders.showSlackButton && <SlackButton />} */}
                    </div>
                  </PermissionProvider>
                )}

              <PermissionProvider roles={[SIEMBA_CUSTOMER]}>
                <div className={'hidden md:block'}>
                  {navHeaders.showInviteCustomer && <InviteCustomer />}
                </div>
              </PermissionProvider>

              <PermissionProvider roles={[SIEMBA_CUSTOMER, SIEMBA_ADMIN]}>
                <div className={'hidden md:block'}>
                  {navHeaders.showStartNewPentest && (
                    <DropdownButton
                      components={[
                        <StartNewEASM key="easm" label="EASM" disabled={APP_MODE === 'genptbeta'} useSearchFlow />,
                        <StartNewVA
                          key="va"
                          label="VUL. ASSESSMENT"
                          disabled={APP_MODE === 'genptbeta'}
                          className="!text-[16px]"
                        />,
                        <StartNewGenPT key="genpt" from="header" label="GENPT" />,
                        <StartNewPentest key="pentest" label="PENTEST" disabled={APP_MODE === 'genptbeta'} />,
                      ]}
                    />
                  )}
                </div>
              </PermissionProvider>

              <PermissionProvider roles={[SIEMBA_CUSTOMER_ENGINEER]}>
                <div className={'hidden md:block'}>
                  {navHeaders.showStartNewPentest && (
                    <DropdownButton
                      components={[
                        <StartNewEASM key="easm" label="EASM" useSearchFlow />,
                        <StartNewGenPT key="genpt" from="header" label="GENPT" />,
                      ]}
                    />
                  )}
                </div>
              </PermissionProvider>
            </div>
            <div className='flex flex-row justify-end gap-4 xl:gap-8'>
              <div className={'my-auto !bg-blue-500'}>
                {navHeaders.showNotifications && (
                  <PermissionProvider>
                    <Notifications />
                  </PermissionProvider>
                )}
              </div>
              {/* min-w to keep icon & dropdown icon horizontal */}
              <div className={'my-auto min-w-[50px]'}>
                {navHeaders.showAccountDropDown && (
                  <PermissionProvider>
                    <AccountDropDown />
                  </PermissionProvider>
                )}
              </div>
            </div>
          </nav>
          <div className={`${styles.expandedMenu} ${isMenuExpanded && styles.active} md:hidden`}>
            <ExpandedMenu />
          </div>
        </header>
      )}
    </>
  );
};

export default Header;
